module.exports = { 
  AD_LOGIN_CALLCENTER: 'adLoginCallcenter',
  CUSTOMER_DATA_CALLCENTER: 'customerDataCallcenter'
};



// WEBPACK FOOTER //
// ./src/const/LocalStorage.js